export default __webpack_public_path__ + "static/icon-4d2dd41bf6710e22329bde8c84a6f9de.png";